import React, { useState } from "react";

import { Tabs, Tab } from "@material-ui/core";
import { getUserData } from "@utils/commonFunctions";
import { TabbingStyle } from "./style";
import AWB from "./awb";
import Consignment from "./consignment";

function Tabbing() {
  const classes = TabbingStyle();
  const [value, setValue] = useState(0);
  const isConnectedCustomer = getUserData()?.connectedCustomer;
  const checkCustomerDivisionHaveManyCustomer = getUserData()?.customerInfo?.length > 1;

  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };

  function TabPanel(props) {
    const { children, value, index } = props;
    return (
      value === index && <div className="tab-pannel-wrapper"> {children} </div>
    );
  }

  return (
    <div className={classes.TabbingWrapper}>
      <div className="white-card tabbing-wrapper">
        <Tabs
          value={value}
          onChange={handleChangeTab}
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="AWB" style={{color:"black"}}/>
          <Tab label="Consignment" style={{color:"black"}}/>
        </Tabs>
        <TabPanel value={value} index={0}>
          <AWB
              isConnectedCustomer={isConnectedCustomer}
              checkCustomerDivisionHaveManyCustomer={checkCustomerDivisionHaveManyCustomer}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Consignment
              isConnectedCustomer={isConnectedCustomer}
              checkCustomerDivisionHaveManyCustomer={checkCustomerDivisionHaveManyCustomer}
          />
        </TabPanel>
      </div>
    </div>
  );
}

export default React.memo(Tabbing);
